import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=c834e0c2"
import script from "./Bag.vue?vue&type=script&lang=js"
export * from "./Bag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports